/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransfersControllerGetTransferQueryResponse, TransfersControllerGetTransferPathParams, TransfersControllerGetTransferQueryParams, TransfersControllerGetTransfer400, TransfersControllerGetTransfer401, TransfersControllerGetTransfer403, TransfersControllerGetTransfer404 } from "../../models/transfersController/TransfersControllerGetTransfer";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { transfersControllerGetTransfer } from "../../clients/transfersService/transfersControllerGetTransfer";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const transfersControllerGetTransferQueryKey = (id: TransfersControllerGetTransferPathParams["id"], params: TransfersControllerGetTransferQueryParams = {}) => [{
  url: '/api/v1/transfers/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TransfersControllerGetTransferQueryKey = ReturnType<typeof transfersControllerGetTransferQueryKey>;
export function transfersControllerGetTransferQueryOptions(id: TransfersControllerGetTransferPathParams["id"], params?: TransfersControllerGetTransferQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = transfersControllerGetTransferQueryKey(id, params);
  return queryOptions<TransfersControllerGetTransferQueryResponse, ResponseErrorConfig<TransfersControllerGetTransfer400 | TransfersControllerGetTransfer401 | TransfersControllerGetTransfer403 | TransfersControllerGetTransfer404>, TransfersControllerGetTransferQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return transfersControllerGetTransfer(id, params, config);
    }
  });
}

/**
 * @summary Get transfer run details
 * {@link /api/v1/transfers/:id}
 */
export function useTransfersControllerGetTransfer<TData = TransfersControllerGetTransferQueryResponse, TQueryData = TransfersControllerGetTransferQueryResponse, TQueryKey extends QueryKey = TransfersControllerGetTransferQueryKey>(id: TransfersControllerGetTransferPathParams["id"], params?: TransfersControllerGetTransferQueryParams, options: {
  query?: Partial<QueryObserverOptions<TransfersControllerGetTransferQueryResponse, ResponseErrorConfig<TransfersControllerGetTransfer400 | TransfersControllerGetTransfer401 | TransfersControllerGetTransfer403 | TransfersControllerGetTransfer404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? transfersControllerGetTransferQueryKey(id, params);
  const query = useQuery({
    ...transfersControllerGetTransferQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TransfersControllerGetTransfer400 | TransfersControllerGetTransfer401 | TransfersControllerGetTransfer403 | TransfersControllerGetTransfer404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}